
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const rp223 = {
    label: "Customer Form Register",
    pageLabel: "Customer Form Register",
    starting: true,
    url: "rp223",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Parent Branch",
            name: "",
            description: "Enter Parent Branch" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Parent Branch",
            name: "ParentBranch",
            description: "Parent Branch"
          },  {
            inputType: "showdata",
            data: "Main Branch",
            textcolor: "black",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Number Of Records",
            name: "",
            description: "" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: " Number Of Records",
            name: "NumberOfreco",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Customer Type",
            name: "",
            description: "Enter Customer Type" 
          },        
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Individual",
                value: "Individual"
              },
              {
                label: "Internal",
                value: "Internal"
              },
              {
                label: "Other",
                value: "Other"
              }
             ],
            placeHolder: "Customer Type",
            name: "CustomerType",
            description: "Enter Customer Type"
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Date",
            name: "",
            description: "" 
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            placeHolder: "",
            label: "",
            name: "date",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Customer No.",
            name: "",
            description: "" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Customer No.",
            name: "CustomerNo",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Form 60/61",
            name: "",
            description: "" 
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Form 60",
                value: "Form 60"
              },
              {
                label: "Form 61",
                value: "Form 61"
              },
              {
                label: "Form 15G",
                value: "Form 15G"
              },
              {
                label: "Form 15H",
                value: "Form 15H"
              }
             ],
            placeHolder: "form60/61",
            name: "form60_61",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Name",
            name: "",
            description: "" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: " Name",
            name: "Name",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "LastName",
            name: "",
            description: "" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: " LastName",
            name: "LastName",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Active",
            name: "Active",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "FirstName",
            name: "",
            description: "" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "FirstName",
            name: "FirstName",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Current Year Balance",
            name: "CurrentYearBalance",
            description: ""
          },
          {
            inputType: "displaytext",            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "" 
          },

    ]
}
export default rp223;